import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import qs from 'query-string';
import { EQueryIdType } from '@src/pages/AppTimeline/types';

const { baseUrl } = window.conviva;

export const useIdType = ({ viewerId, clientId, flowId, existedIdType }) => {
  const navigate = useNavigate();
  const [idType, setIdType] = useState<EQueryIdType>(EQueryIdType.userId);

  useEffect(() => {
    if (existedIdType) {
      setIdType(existedIdType);
      return;
    }
    if (viewerId) {
      setIdType(EQueryIdType.userId);
      return;
    }
    if (clientId) {
      setIdType(EQueryIdType.clientId);
      return;
    }
  }, [viewerId, clientId, existedIdType]);

  const handleIdSelectChanged = () => {
    navigate(
      qs.stringifyUrl({
        url: `${baseUrl}/dashboard/user-timeline`,
        query: {
          flowId,
        },
      }),
      { replace: true },
    );
  };

  return {
    idType,
    handleIdSelectChanged,
  };
};
